<div class="drawer-table-wrapper">
  <nz-table
    #notificationSettings
    [nzData]="(listOfData$ | async) ?? []"
    [nzLoading]="loading$ | async"
    [nzScroll]="{ x: '700px', y: 'calc(100vh - 200px)' }"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th scope="col" nzWidth="70%" [title]="listOfColumn[0].title">
          {{ listOfColumn[0].title }}
        </th>
        <th scope="col" nzWidth="15%" [title]="listOfColumn[1].title">
          {{ listOfColumn[1].title }}
        </th>
        <th scope="col" nzWidth="15%" [title]="listOfColumn[2].title">
          {{ listOfColumn[2].title }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of notificationSettings.data">
        <td>
          <ng-container *ngIf="data.description.includes('XX')">
            <span>{{ data.description.split('XX')[0] }}</span>
            <ng-container
              *ngIf="!showNotificationSettings; else editableThreshold">
              <span class="admin-only-value">{{ data.thresholdDays }}</span>
            </ng-container>
            <ng-template #editableThreshold>
              <nz-input-number
                [ngModel]="data.thresholdDays"
                (ngModelChange)="updateThreshold(data, $event)"
                (blur)="onBlurThreshold(data, data.thresholdDays)"
                [nzMin]="1"
                [nzMax]="getMaxValue(data)"
                [nzDisabled]="loading$ | async"
                [nzSize]="'small'"
                class="input-width"></nz-input-number>
            </ng-template>
            <span>{{ data.description.split('XX')[1] }}</span>
          </ng-container>
          <ng-container *ngIf="!data.description.includes('XX')">
            {{ data.description }}
          </ng-container>
        </td>
        <td>
          <nz-switch
            *ngIf="data.isAdminOnly || showNotificationSettings"
            [(ngModel)]="data.inApp"
            (ngModelChange)="toggleInAppNotification(data)"
            [nzLoading]="loading$ | async" />
        </td>
        <td>
          <nz-switch
            *ngIf="data.isAdminOnly || showNotificationSettings"
            [(ngModel)]="data.inEmail"
            (ngModelChange)="toggleEmailNotification(data)"
            [nzLoading]="loading$ | async" />
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
